import { memo } from "react";
import { useHistory } from "react-router";
import { useFormik } from "formik";
import { toast } from "react-toastify";

// Components
import { TextField, Button } from "../../../components/UI";
import { Paragraph, Span } from "../../../components/typography";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// Form Models
import { ForgotPasswrodFormModel } from "../../../models/app/forms";

// Services
import { forgotPasswordValidate } from "../../../services/validations/forgotPassword.validations";

// Calls
import { forgotPasswordRequest } from "../../../api/calls/app.call";

// Styles
import { ForgotPasswordFormStyles } from "./forgotPassword.styles";

const ForgotPasswordForm = ({ onSuccess }) => {
  const history = useHistory();

  const handleForgotPassword = async values => {
    const response = await forgotPasswordRequest(values);
    if (response.hasError) {
      toast.error(response.error.message);
      return;
    }
    toast.success(response.message);
    onSuccess();
  };

  const formik = useFormik({
    initialValues: new ForgotPasswrodFormModel(),
    onSubmit: handleForgotPassword,
    validate: forgotPasswordValidate
  });

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } =
    formik;
  return (
    <ForgotPasswordFormStyles>
      <form onSubmit={handleSubmit} className="form">
        <div>
          <TextField
            placeholder="Email address"
            name="email"
            type="email"
            value={values.email}
            touched={touched.email}
            error={errors.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
        <Button
          type="submit"
          buttonDesignType={buttonDesignType.PRIMARY}
          style={{ width: "100%" }}
        >
          Send Reset Link
        </Button>
        <Paragraph className="backToLogin">
          Remember your password?{" "}
          <Span className="link" onClick={() => history.push("/")}>
            Log In
          </Span>
        </Paragraph>
      </form>
    </ForgotPasswordFormStyles>
  );
};

export default memo(ForgotPasswordForm);
